'use client';

import { Draggable } from '@hello-pangea/dnd';
import { styled } from '@linaria/react';
import Image from 'next/image';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';

const Card = styled.div`
  padding: 12px;
  border-radius: 6px;
  display: flex;
  column-gap: 12px;
  padding: 8px 12px;
  background-color: #f6f8fc;
  border-radius: 6px;
  align-items: center;
`;

const ImageButton = styled.button<{ marginRight?: number }>`
  cursor: pointer;
  margin-right: ${({ marginRight }) => marginRight || 0}px;

  &:disabled {
    cursor: not-allowed;
  }
`;

const PopTopicContent = styled.div`
  flex: 1;
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: 0.5px;
  color: #383838;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TagContent = styled.div`
  flex: 1;
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: 0.5px;
  color: #515c69;
  min-width: 236px;

  @media screen and (max-width: ${SCREEN_SIZE.TABLET}px) {
    min-width: 211px;
  }

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: #e03f19;
  }
`;

type DragCardProps = {
  index: number;
  id: string;
  name: string;
  onTop: (item: string) => void;
  isPopTopic?: boolean;
  onDelete: (item: string) => void;
};

const DragCard = ({ index, onTop, isPopTopic, name, onDelete, id }: DragCardProps) => {
  return (
    <Draggable draggableId={id} index={index} isDragDisabled={!isPopTopic}>
      {(provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
          <Card>
            <ImageButton onClick={() => onDelete(id)} aria-label='delete' disabled={name === '全部'}>
              <Image src='/assets/icons/icon-minus.svg' alt='delete' width={20} height={20} unoptimized />
            </ImageButton>
            {isPopTopic ? (
              <>
                <PopTopicContent>{name}</PopTopicContent>
                <ImageButton marginRight={4} onClick={() => onTop(id)} aria-label='to-top'>
                  <Image src='/assets/icons/icon-top.svg' alt='to-top' width={24} height={24} unoptimized />
                </ImageButton>
                <div>
                  <Image src='/assets/icons/icon-reorder.svg' alt='reorder' width={24} height={24} unoptimized />
                </div>
              </>
            ) : (
              <TagContent>
                <span>#</span>
                {name}
              </TagContent>
            )}
          </Card>
        </div>
      )}
    </Draggable>
  );
};

export default DragCard;
